export const SETTINGS_SIDE_ALL = 0;
export const SETTINGS_SIDE_FRONTEND = 1;
export const SETTINGS_SIDE_BACKEND = 1;